import React, { FC } from 'react';
import { FlexRow, BodyTextSmall } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { useTranslation } from '@blocs.i18n';
import { StyledMediaUploaderModal } from './styles';

type MediaUploaderModalProps = {
  children: React.ReactNode;
  isModalOpen: boolean;
  toggleModal: () => void;
  isFooterHidden: boolean;
  isHeaderHidden: boolean;
  handleCancelClick?: () => void;
  handleSubmitClick?: () => void;
  submitDisabled?: boolean;
};

export const MediaUploaderModal: FC<MediaUploaderModalProps> = ({
  children,
  isModalOpen,
  toggleModal,
  isFooterHidden,
  isHeaderHidden,
  handleCancelClick,
  handleSubmitClick,
  submitDisabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <StyledMediaUploaderModal
      isOpen={isModalOpen}
      isHeaderHidden={isHeaderHidden}
      isFooterHidden={isFooterHidden}
      title={
        <FlexRow gap="2" textColor="link" alignItems="center" data-testid="media-upload-modal-title">
          <Icon name="computer" size="md" inheritColor />
          <BodyTextSmall color="link" fontWeight="bold" className="ml-1">
            {t('common:cloudinaryUploader.menu.files')}
          </BodyTextSmall>
        </FlexRow>
      }
      modalSize="medium"
      handleToggleClick={toggleModal}
      cancelLabel={t('common:button.cancel')}
      submitLabel={t('common:button.confirm')}
      handleCancelClick={handleCancelClick}
      handleSubmitClick={handleSubmitClick}
      submitDisabled={submitDisabled}
      data-testid="media-upload-modal"
      data-qa-id="media-upload-modal"
    >
      {children}
    </StyledMediaUploaderModal>
  );
};
